import { createDynamicSlice } from ".";
import { fetchSurveyThunk } from "../thunks/surveyThunk";

export const surveySlice = createDynamicSlice({
  name: "survey",
  thunk: fetchSurveyThunk,
  listMode: true,
  resetActionName: "resetSurvey",
});

export const surveyReducer = surveySlice.reducer;
export const { resetSurvey } = surveySlice.actions;
